import React from 'react';
import { motion } from 'framer-motion';
import { Play, Clock, Repeat } from 'lucide-react';
import { GlassCard } from '@/components/GlassCard';
import { calcTotalDuration, totalRounds, formatTime } from '@/models/models';

export const WorkoutCard = ({ routine, onStart, testId }) => {
  const duration = calcTotalDuration(routine);
  const rounds = totalRounds(routine);
  const accent = routine.blocks?.[0]?.color || '#38BDF8';

  return (
    <motion.div
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.99 }}
      transition={{ duration: 0.2 }}
    >
      <GlassCard className="flex flex-col gap-4" data-testid={testId}>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#38BDF8]">
              Featured
            </p>
            <h3 className="mt-1 text-2xl font-extrabold text-white">
              {routine.name}
            </h3>
          </div>
          <span
            className="h-12 w-12 rounded-2xl"
            style={{
              background: `linear-gradient(135deg, ${accent}, ${accent}55)`,
              boxShadow: `0 0 24px ${accent}55`,
            }}
          />
        </div>

        <div className="flex flex-wrap gap-4 text-sm text-[#CBD5E1]">
          <span className="flex items-center gap-1.5">
            <Play size={15} className="text-[#EF4444]" />
            {routine.blocks[0].work}s Work
          </span>
          <span className="flex items-center gap-1.5">
            <Clock size={15} className="text-[#22C55E]" />
            {routine.blocks[0].rest}s Rest
          </span>
          <span className="flex items-center gap-1.5">
            <Repeat size={15} className="text-[#F59E0B]" />
            {rounds} Rounds
          </span>
          <span className="flex items-center gap-1.5 font-bold text-white tabular-nums">
            {formatTime(duration)} Total
          </span>
        </div>

        <motion.button
          whileTap={{ scale: 0.97 }}
          onClick={onStart}
          data-testid={testId ? `${testId}-start` : 'workout-card-start'}
          className="mt-1 flex min-h-[56px] w-full items-center justify-center gap-2 rounded-2xl bg-[#EF4444] text-lg font-extrabold tracking-widest text-white hover:brightness-110"
        >
          <Play size={20} fill="currentColor" /> START
        </motion.button>
      </GlassCard>
    </motion.div>
  );
};

export default WorkoutCard;
